let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6zfzy"), load("943D1")]).then(() => parcelRequire('ddp7n'));